import { render, staticRenderFns } from "./BibTabs.vue?vue&type=template&id=d53a90bc&scoped=true"
import script from "./BibTabs.vue?vue&type=script&lang=js"
export * from "./BibTabs.vue?vue&type=script&lang=js"
import style0 from "./BibTabs.vue?vue&type=style&index=0&id=d53a90bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53a90bc",
  null
  
)

export default component.exports